export const FORM_SCHEMA = {
    context: {
        fields: {
            country: {
                table: 'tblCountries',
            },
            defaultTimezone: {
                table: 'tblTimezones',
            },
        },
    },
    required: [
        'implementationName',
        'implementationType',
        'userRequested',
        'isFreeReason',
        'templateSelection',
        'licenseEdition',
        'totalUsersPurchased',
        'Name',
        'Lastname',
        'Email',
        'Phone',
        'selectPartner',
        'partnerUsers',
        'country',
        'defaultTimezone',
    ],
    properties: {
        name: {
            maxLength: 200,
            type: ['string'],
        },
        implementationName: {
            maxLength: 50,
            type: ['string'],
        },
    },
    layout: {
        id: 'implementation',
        uiGrid: 'linearVertical',
        composition: [
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_info',
                composition: [
                    {
                        schemaId: 'implementationName',
                        label: 'cfm_label_implementation_name',
                        uiType: 'text',
                    },
                    {
                        schemaId: 'isFree',
                        label: 'cfm_label_is_free',
                        uiType: 'checkbox',
                    },
                    {
                        schemaId: 'userRequested',
                        label: 'cfm_label_user_requested',
                        uiType: 'text',
                    },
                    {
                        schemaId: 'isFreeReason',
                        label: 'cfm_label_is_free_reason',
                        uiType: 'list',
                        options: [
                            { value: 1, label: 'Partner' },
                            { value: 2, label: 'Friend' },
                            { value: 3, label: 'Demo' },
                            { value: 4, label: 'Template' },
                            { value: 5, label: 'Test' },
                            { value: 6, label: 'Development/Product' },
                            { value: 7, label: 'Sandbox' },
                            { value: 8, label: 'Onboarding' },
                            { value: 9, label: 'Old customer/Keep Data' },
                            { value: 10, label: 'Dummy' },
                            { value: 11, label: 'Mockup_Prospect' },
                            { value: 12, label: 'Trying to win back the customer' },
                        ],
                    },
                    {
                        schemaId: 'selectCustomer',
                        label: 'cfm_label_select_customer',
                        uiType: 'list',
                        isHidden: true,
                        options: [
                            {
                                label: 'Customer 1',
                                value: '1',
                            },
                            {
                                label: 'Customer 2',
                                value: '2',
                            },
                        ],
                    },
                    {
                        schemaId: 'implementationType',
                        label: 'cfm_label_implementation_type',
                        uiType: 'list',
                    },
                    {
                        schemaId: 'templateSelection',
                        label: 'cfm_label_template_selection',
                        uiType: 'list',
                    },
                    {
                        schemaId: 'licenseEdition',
                        label: 'cfm_label_license_edition',
                        uiType: 'list',
                    },
                    {
                        schemaId: 'recurlyReference',
                        label: 'cfm_label_recurly_reference',
                        uiType: 'text',
                        isHidden: true,
                    },
                    {
                        schemaId: 'totalUsersPurchased',
                        label: 'cfm_label_total_users_purchased',
                        uiType: 'integer',
                    },
                    {
                        schemaId: 'implementationUrl',
                        label: 'cfm_label_info_link_proyecto',
                        uiType: 'text',
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_tab_user_data',
                composition: [
                    {
                        schemaId: 'Name',
                        label: 'cfm_label_first_user_name',
                        uiType: 'text',
                    },
                    {
                        schemaId: 'Lastname',
                        label: 'cfm_label_first_user_surname',
                        uiType: 'text',
                    },
                    {
                        schemaId: 'Email',
                        label: 'cfm_label_first_user_email',
                        uiType: 'text',
                    },
                    {
                        schemaId: 'Phone',
                        label: 'cfm_label_first_user_phone',
                        uiType: 'text',
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_tab_partner_data',
                composition: [
                    {
                        schemaId: 'isPartner',
                        label: 'cfm_label_is_partner',
                        uiType: 'checkbox',
                    },
                    {
                        schemaId: 'customerOfPartner',
                        label: 'cfm_label_customer_of_partner',
                        uiType: 'checkbox',
                        isHidden: true,
                    },
                    {
                        schemaId: 'selectPartner',
                        label: 'cfm_label_select_partner',
                        uiType: 'list',
                        isHidden: true,
                    },
                    {
                        schemaId: 'extIds',
                        label: 'label_external_partner_code',
                        uiType: 'text',
                        isHidden: true,
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_tab_extra_data',
                composition: [
                    {
                        schemaId: 'country',
                        label: 'cfm_label_country',
                        uiType: 'list',
                    },
                    {
                        schemaId: 'defaultTimezone',
                        label: 'cfm_label_default_timezone',
                        uiType: 'list',
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_client_partners',
                composition: [
                    {
                        schemaId: 'responsiblepartner',
                        label: 'cfm_label_responsible_partners',
                        uiType: 'multiList',
                    },
                ],
            },
        ],
    },
};
